/* ===================================================================
   OMR · GUARDA DEL CODIGO DE BUNDLE
   assets/omr-bundle-code-guard.js

   EL PROBLEMA QUE RESUELVE
   El bundle «Ahorra con nuestros packs» de la PDP cobra con un codigo por
   producto, FBT-BUNDLE-<productId>, que product-bundle.js aplica con
   /discount/<codigo>. Shopify guarda ese codigo en la SESION y lo aplica a
   cualquier carrito que tenga 2 unidades de la coleccion bundle-<productId>,
   aunque sean dos prendas iguales: cantidad minima 2 es lo unico que Shopify
   sabe condicionar. Resultado medido el 2026-10-03: 2 shorts iguales cobraban
   S/ 112.10 (5 %) en vez de S/ 115.00 (tramo Buy 2 de Fast Bundle), porque el
   codigo es incombinable y gana el mayor descuento.

   LO QUE HACE
   Si hay un FBT-BUNDLE-<id> aplicado o pendiente en la sesion y el carrito NO
   contiene el pack (el producto ancla <id> mas al menos otro producto distinto
   de la coleccion bundle-<id>), lo quita con /cart/update.js {discount: ""}.
   Con el pack completo no toca nada: short + BVD sigue cobrando su 5 %.

   CUANDO CORRE
   - Al cargar cada pagina (cubre la pagina del carrito y el codigo pendiente).
   - Despues de cada cambio de carrito (add / change / update / clear) hecho con
     el fetch de la pagina, ANTES de devolver el control a quien lo pidio.
   - Cada vez que el theme emite 'cart-update' (red de seguridad: el add de
     Fast Bundle usa su propia referencia a fetch y se salta el envoltorio).

   LO QUE NO CUBRE (declarado, no olvidado)
   - «Comprar ahora» (boton de pago nativo de Shopify): salta el carrito y
     no pasa por aqui. Con la sesion limpia no hay codigo que arrastrar.
   - Un carrito con el pack completo MAS dos shorts iguales: el codigo sigue
     aplicando a toda la coleccion. Es el limite de Shopify, no del guard.

   Falla en abierto: si no puede leer el carrito o la coleccion, no quita nada.
   =================================================================== */
(function () {
  'use strict';

  if (window.__omrBundleCodeGuard) return;
  window.__omrBundleCodeGuard = true;

  var CODE_RE = /^FBT-BUNDLE-(\d+)$/;
  var MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?$|\/cart\/\d+:\d+/;

  var origFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!origFetch) return;

  var memberCache = {};
  var running = null;

  function getJSON(url) {
    return origFetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function anchorOf(title) {
    var m = CODE_RE.exec(title || '');
    return m ? m[1] : null;
  }

  function readStored() {
    try { return window.localStorage.getItem('storedDiscount') || ''; } catch (e) { return ''; }
  }

  function anchorsIn(cart) {
    var found = {};
    var a;
    (cart.items || []).forEach(function (item) {
      (item.discounts || []).forEach(function (d) {
        if ((a = anchorOf(d.title))) found[a] = true;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if ((a = anchorOf(d.title))) found[a] = true;
    });
    /* El codigo pendiente no aparece en cart.js hasta que el carrito califica.
       El theme lo anota en localStorage al aplicarlo: es la pista del pendiente. */
    if ((a = anchorOf(readStored()))) found[a] = true;
    return Object.keys(found);
  }

  /* Productos de la coleccion bundle-<id>: la misma que usa el descuento. */
  function membersOf(anchor) {
    if (!memberCache[anchor]) {
      memberCache[anchor] = getJSON('/collections/bundle-' + anchor + '/products.json?limit=250')
        .then(function (json) {
          var set = {};
          (json.products || []).forEach(function (p) { set[p.id] = true; });
          return set;
        })
        .catch(function (err) { delete memberCache[anchor]; throw err; });
    }
    return memberCache[anchor];
  }

  function packIntact(cart, anchor, set) {
    var present = {};
    (cart.items || []).forEach(function (item) {
      if (set[item.product_id]) present[item.product_id] = true;
    });
    return !!present[anchor] && Object.keys(present).length >= 2;
  }

  function clearCodes() {
    return origFetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (cart) {
      try {
        if (CODE_RE.test(readStored())) window.localStorage.removeItem('storedDiscount');
      } catch (e) { /* sin storage: no pasa nada */ }
      return cart;
    });
  }

  /* Repinta lo que el theme ya sabe repintar. No se inventa un segundo pintor. */
  function refreshUI(cart) {
    var onCartPage = /\/cart\/?$/.test(window.location.pathname);
    if (onCartPage) {
      var key = 'omrBundleGuardReload';
      var last = 0;
      try { last = parseInt(window.sessionStorage.getItem(key) || '0', 10); } catch (e) { /* ignorar */ }
      if (Date.now() - last > 10000) {
        try { window.sessionStorage.setItem(key, String(Date.now())); } catch (e) { /* ignorar */ }
        window.location.reload();
      }
      return;
    }
    /* El theme no expone `halo`; expone sharedFunctions (theme.js, mismo punto que
       usan halo-toolcart.js y quick-order-list.js para repintar el drawer). */
    var shared = window.sharedFunctions;
    if (shared && typeof shared.updateSidebarCart === 'function') {
      shared.updateSidebarCart(cart);
    }
  }

  function guard() {
    if (running) return running;
    running = getJSON('/cart.js')
      .then(function (cart) {
        var anchors = anchorsIn(cart);
        if (!anchors.length) return false;
        return Promise.all(anchors.map(function (a) {
          return membersOf(a).then(function (set) { return { ok: true, intact: packIntact(cart, a, set) }; },
                                   function () { return { ok: false }; });
        })).then(function (results) {
          /* Falla en abierto: una coleccion ilegible impide concluir nada. */
          var unreadable = results.some(function (r) { return !r.ok; });
          var anyIntact = results.some(function (r) { return r.ok && r.intact; });
          if (unreadable || anyIntact) return false;
          return clearCodes().then(function (fresh) { refreshUI(fresh); return true; });
        });
      })
      .catch(function () { return false; })
      .then(function (changed) { running = null; return changed; });
    return running;
  }

  /* fetch: tras un cambio de carrito se espera al guard antes de devolver la respuesta. */
  window.fetch = function (input, init) {
    var promise = origFetch(input, init);
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) { /* ignorar */ }
    var path = url.split('?')[0];
    if (!MUTATION_RE.test(path)) return promise;
    return promise.then(function (response) {
      return guard().then(function () { return response; });
    });
  };

  /* XMLHttpRequest ($.ajax / $.post del theme): no se puede retrasar la respuesta. */
  var xhrOpen = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  if (xhrOpen) {
    window.XMLHttpRequest.prototype.open = function (method, url) {
      var path = String(url || '').split('?')[0];
      if (MUTATION_RE.test(path)) {
        this.addEventListener('loadend', function () { guard(); });
      }
      return xhrOpen.apply(this, arguments);
    };
  }

  /* Fast Bundle anade con su propia referencia a fetch y se salta el envoltorio de
     arriba. El theme emite 'cart-update' cada vez que repinta el drawer, venga de
     donde venga el cambio: es la red de seguridad. Cuesta un repintado del drawer
     cuando hay que limpiar; sin codigo que limpiar no hace nada visible. */
  document.addEventListener('cart-update', function () { guard(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guard);
  } else {
    guard();
  }
})();
